import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public static selfDomain: String = 'https://mira.myanatomy.in/imm';
  static apiDomain: string = 'https://mira-api.myanatomy.in';
  public defaultMATCHRedirectionURL: string = 'https://match.myanatomy.in';
  public defaultMAPITRedirectionURL: string = 'https://mymapit.in';
  processId: string;
  static http: Http;
  public static eventId: string;
  public static tokenId: string;

  constructor(private http: Http) {
    this.http = http;
  }
  
  public static sessionExpireRedirection() {
    this.clearSessionObject();
    setTimeout(() => location.assign(this.selfDomain + '/login/auth/uus?sessionExpired=true'), 1000);
  }

  getRequest(apiUrl) {

  }
  public verifySession(modelObject) {
    let empHeaders = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(ApiService.apiDomain + '/ims/api/getSessionData' , JSON.stringify(modelObject), { headers: empHeaders })
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
  }
  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }

  public static getDomainName() {
    return this.apiDomain;
  }

  public getDefaultRedirectionURL() {
    switch(this.getClient()) {
      case 'MATCH': {
        return this.getRedirectURL() || this.defaultMATCHRedirectionURL;
      }
      case 'MAPIT': {
        return this.getRedirectURL() || this.defaultMAPITRedirectionURL;
      }
      default: {
        return this.getRedirectURL() || this.defaultMATCHRedirectionURL;        
      }
    }
  }

  public getHostName() {
    // return this.window.location.hostname;
   }

  public getEventId() {
    return localStorage.getItem("eventId");
  }

  public getEventName() {
    return localStorage.getItem('session')
            ? this.getSession().eventName
            : null;
}

  public getTokenId() {
    return localStorage.getItem("tokenId");
  }

  public getSessionId() {
    return localStorage.getItem('session')
            ? this.getSession().sessionId
            : null;
  }

  public getClient() {
    return localStorage.getItem('session')
            ? this.getSession().client
            : null;
  }

  public getCandidateDataSource() {
    return localStorage.getItem('session')
            ? this.getSession().candidateDataSource
            : null;
  }

  public getEventDataSource() {
    return localStorage.getItem('session')
            ? this.getSession().eventDataSource
            : null;
  }

  public getRedirectURL() {
    return localStorage.getItem('session')
            ? this.getSession().redirectUrl
            : null;
  }

  public getLandingURL() {
    return localStorage.getItem('session')
            ? this.getSession().landingUrl
            : null;
  }

  public getStringifySessionObj() {
    return JSON.stringify(this.getSessionObj());
  }

  public getSessionObj() {
    return {
      eventId: this.getEventId(),
      tokenId: this.getTokenId(),
      sessionId: this.getSessionId(),
      client: this.getClient(),
      candidateDataSource: this.getCandidateDataSource(),
      eventDataSource: this.getEventDataSource(),
      redirectUrl: this.getRedirectURL(),
      mapitTestId: this.getMapitTestId(),
      matchEventId: this.getMatchEventId()
    }
  }

  public getSession() {
    try {
      if (localStorage.getItem('session')) {
        return JSON.parse(localStorage.getItem('session'));
      } else {
        return {};
      }
    } catch (error) {
      return {};
    }
  }

  public getMapitTestId() {
    return localStorage.getItem('session')
            ? this.getSession().testId
            : null;
  }

  public getMatchEventId() {
    return localStorage.getItem('session')
            ? this.getSession().eventId
            : null;
  }

  public setSessionObject(sessionObj: any) {
    localStorage.setItem('eventId', sessionObj.eventId);
    localStorage.setItem('tokenId', sessionObj.token);
    localStorage.setItem('session', JSON.stringify(sessionObj));
    return true;
  }

  public static clearSessionObject() {
    localStorage.clear();
  }
}
